import React, { useEffect } from 'react';
import styles from './styles.module.scss';
import { useTranslation } from 'next-i18next';
import LayoutWrapper from 'src/shared/components/LayoutWrapper';
import Section from 'src/shared/components/Section';
import RoundedButton from 'src/shared/components/RoundedButton';
import IconGrid from 'src/components/IconGrid';
import Image from 'src/shared/components/Image';
import RoutePaths from 'src/config/RoutePaths';
import common from 'src/shared/utils/common';
import useRouter from 'src/shared/hooks/useRouter';
import GaService from 'src/services/GaService';
import GaCategory from 'src/config/GaCategory';
import GaAction from 'src/config/GaAction';
import MetaData from 'src/config/MetaData';

const pageInfo = MetaData[RoutePaths.HOW_IT_WORKS];

const HowItWorks = () => {
    const { t } = useTranslation();
    const { route } = useRouter();

    const clickViewStrategyButton = () => {
        GaService.callEvent(GaCategory.marketing, GaAction.clickViewStrategiesButton, 'how it works');
    };

    useEffect(() => {
        GaService.pageView(route);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <LayoutWrapper
            className={styles.container}
            headerProps={{ type: 'black', fixed: true }}
            metaProps={{ title: pageInfo.title, description: pageInfo.description, keywords: pageInfo.keywords }}
        >
            <div className={styles.page}>
                <Section
                    className={styles.headSection}
                    containerStyle={{ padding: '100px 0', backgroundImage: "url('/static/images/HowItWorks(Banner)@2x.png')" }}
                >
                    <div className={styles.layer}>
                        <p className={styles.title}>{t('how_it_works_hero_title')}</p>
                        <p className={styles.content}>{t('how_it_works_hero_description')}</p>
                    </div>
                </Section>
                <Section className={styles.infoOneSection} fullWidth>
                    <p className={styles.title}>{t('how_it_works_intro_title_1')}</p>
                    <p className={styles.content}>{t('how_it_works_intro_description_1')}</p>
                    <Image multiLang width="1230px" animation="fade" src="/static/images/DashboardMockup.png" />
                </Section>
                <Section className={styles.infoTwoSection} containerStyle={{ background: styles.secondaryColorDark }}>
                    <p className={styles.title}>{t('how_it_works_intro_title_2')}</p>
                    <p className={styles.content}>{t('how_it_works_intro_description_2')}</p>
                    <div className={styles.iconGroup}>
                        <IconGrid src="/static/images/svg/CompleteProfile(Icon)@3x.svg">
                            <p className={styles.title}>{t('how_it_works_intro_step_1_title')}</p>
                            <p className={styles.content}>{t('how_it_works_intro_step_1_description')}</p>
                        </IconGrid>
                        {/* <IconGrid src="/static/images/svg/ReqAllocation(Icon)@3x.svg"> */}
                        <IconGrid multiLang src="/static/images/ReqAllocation(Icon)@2x.png">
                            <p className={styles.title}>{t('how_it_works_intro_step_2_title')}</p>
                            <p className={styles.content}>{t('how_it_works_intro_step_2_description')}</p>
                        </IconGrid>
                    </div>
                    <div className={styles.iconGroup}>
                        <IconGrid src="/static/images/svg/IGHOOS(Icon)@3x.svg">
                            <p className={styles.title}>{t('how_it_works_intro_step_3_title')}</p>
                            <p className={styles.content}>{t('how_it_works_intro_step_3_description')}</p>
                        </IconGrid>
                        <IconGrid src="/static/images/svg/ESign(Icon)@3x.svg">
                            <p className={styles.title}>{t('how_it_works_intro_step_4_title')}</p>
                            <p className={styles.content}>{t('how_it_works_intro_step_4_description')}</p>
                        </IconGrid>
                    </div>
                </Section>
                <Section className={styles.infoThreeSection} containerStyle={{ background: styles.primaryColorLight }}>
                    <p className={styles.title}>{t('how_it_works_intro_title_3')}</p>
                    <p className={styles.content}>{t('how_it_works_intro_description_3')}</p>
                    <div className={styles.iconGroup}>
                        <IconGrid src="/static/images/svg/Cashflow(Icon)@3x.svg">
                            <p className={styles.title}>{t('how_it_works_intro_highlight_1_title')}</p>
                            <p className={styles.content}>{t('how_it_works_intro_highlight_1_description')}</p>
                        </IconGrid>
                        <IconGrid src="/static/images/svg/Reporting(Icon)@3x.svg">
                            <p className={styles.title}>{t('how_it_works_intro_highlight_2_title')}</p>
                            <p className={styles.content}>{t('how_it_works_intro_highlight_2_description')}</p>
                        </IconGrid>
                    </div>
                </Section>
            </div>
        </LayoutWrapper>
    );
};

export default HowItWorks;
